import DatePickerContainer from './DatePickerContainer';
import DayPicker from './daypicker/Container.inner';
import MonthPicker from './monthpicker/Contaniner.inner';

export type FilterAlternativeProps = {
  label?: string;
  value?: string;
  id?: string;
};

export type DatePickerProps = {
  monthly?: boolean;
  minDate?: Date;
  maxDate?: Date;
  filterAlternatives?: Array<FilterAlternativeProps>;
  currentFilterAlternative?: FilterAlternativeProps;
  setCurrentFilterAlternative?;
  monthsShown?: number;
  defaultValue: string;
  onChange?;
  disabled: boolean;
  displayFormat?: 'DD/MM/AA' | 'yyyy-MM-dd' | 'MMMM yyyy' | 'dd-MM-yyyy' | 'dd/MM/yyyy';
  alignLeft?: boolean;
  withoutElevation?: boolean;
  label?: string;
  placeholder?: string;
  id?: string;
};

const DatePicker = (props: DatePickerProps) => {
  const {
    monthly,
    minDate,
    maxDate,
    filterAlternatives,
    setCurrentFilterAlternative,
    defaultValue,
    disabled,
    displayFormat = 'yyyy-MM-dd',
    alignLeft = false,
  } = props;
  const getDateFormat = () => {
    if (displayFormat === 'DD/MM/AA') return 'dd/MM/yy';
    if (displayFormat === 'MMMM yyyy') return 'MMMM yyyy';
    if (displayFormat === 'dd-MM-yyyy') return 'dd-MM-yyyy';
    if (displayFormat === 'dd/MM/yyyy') return 'dd/MM/yyyy';
    return 'yyyy-MM-dd';
  };

  if (monthly)
    return (
      <DatePickerContainer
        {...props}
        filterAlternatives={filterAlternatives}
        setCurrentFilterAlternative={setCurrentFilterAlternative}
        dateFormat={getDateFormat()}
        alignLeft={alignLeft}
      >
        <MonthPicker minBookingDate={minDate} maxBookingDate={maxDate} />
      </DatePickerContainer>
    );
  return (
    <DatePickerContainer
      {...props}
      filterAlternatives={filterAlternatives}
      setCurrentFilterAlternative={setCurrentFilterAlternative}
      defaultValue={defaultValue}
      onChange={props.onChange}
      disabled={props.disabled}
      dateFormat={getDateFormat()}
      alignLeft={alignLeft}
    >
      <DayPicker
        minBookingDate={minDate}
        maxBookingDate={maxDate}
        numberOfMonths={1}
      />
    </DatePickerContainer>
  );
};
export default DatePicker;
